module.exports = __webpack_public_path__ + "static/media/libras.731299f0.svg";